<template>
  <div>
    <v-autocomplete
      autocomplete="off"
      v-model="modelUUID"
      :label="label"
      :items="modelOptions"
      item-text="label"
      item-value="uuid"
      persistent-hint
      :hint="hint"
      :search-input.sync="modelSearch"
      color="primary"
      @input.native="loadModels($event, $data)"
      required
      :rules="rules"
      :disabled="disabled"
      clearable
    >
    </v-autocomplete>
    <warning-dialog
      :dialog="warningDialog"
      :item="initialModel"
      :text="warningText"
      :title="warningTitle"
      @agree="handleDialogOutput"
      v-show="false"
    />
  </div>
</template>

<script>
import api from "@/utils/api";
import debounce from "@/plugins/debounce";
import WarningDialog from "@/components/dialogs/WarningDialog.vue";

export default {
  name: "ModelSelector",

  props: {
    modelUuid: {
      type: String,
      default: String,
    },
    initialData: {
      type: Object,
      default: Object,
    },
    isWarningDialogAvailable: {
      type: Boolean,
      default: Boolean,
    },
    rules: {
      type: Array,
      default: Array,
    },
    disabled: {
      type: Boolean,
      default: Boolean,
    },
    label: {
      type: String,
      default: function () {
        return this.$t("components.selectors.modelSelector.sentinelSN");
      },
    },
    hint: {
      type: String,
      default: function () {
        return this.$t("components.selectors.modelSelector.required");
      },
    },
  },
  components: { WarningDialog },
  data: () => ({
    modelOptions: [],
    modelSearch: "",
    warningDialog: false,
    pendingModelUUID: null,
    initialModel: null,
    initialModelUuid: null,
    warningText: "",
    warningTitle: "",
  }),
  created() {
    this.setInitalData();
    this.loadModels(null, this).then((resp) => {
      if (Object.keys(this.initialData).length !== 0) {
        this.initialData.label =
          this.initialData.brand_name + " " + this.initialData.model;
        this.initailModel = this.initialData.model;
        this.initialModelUuid = this.initialData.uuid;
        this.modelOptions.push(this.initialData);
        // this.modelUUID = this.initialData.uuid;
      }
    });
  },
  computed: {
    modelUUID: {
      get: function () {
        return this.modelUuid;
      },
      set: function (value) {
        if (this.showDialog) {
          this.warningDialog = true;
          this.pendingModelUUID = value;
          this.modelSearch = "";
          this.loadModels(null, this);
        } else {
          this.loadNewBoatItems(value);
          this.$emit("update:modelUuid", value);
        }
      },
    },
    showDialog: function () {
      return (
        this.isWarningDialogAvailable &&
        this.modelUuid &&
        !this.pendingModelUUID
      );
    },
  },
  methods: {
    setInitalData() {
      this.warningText = this.$t(
        "components.selectors.modelSelector.allStandardEquipmentInformationWillBeLostANewTelematicsProfileWillBeAppliedToTheBoat"
      );
      this.warningTitle = this.$t(
        "components.selectors.modelSelector.areYouSureYouWantToChangeModel"
      );
    },
    handleDialogOutput(agreed) {
      if (agreed) {
        this.modelUUID = this.pendingModelUUID;
      }

      this.warningDialog = false;
    },

    loadNewBoatItems(value) {
      this.$emit(
        "reload-boat-items",
        this.modelOptions.find((el) => el.uuid === value)
      );
    },

    loadModels() {
      return new Promise((resolve, reject) => {
        this.modelSearch =
          typeof this.modelSearch !== "undefined" && this.modelSearch !== null
            ? this.modelSearch
            : "";

        api
          .getModelList({
            search: this.modelSearch,
            include_documents_and_items: true,
          })
          .then((resp) => {
            resp.data.results.forEach((element) => {
              if (!this.modelOptions.find((el) => el.uuid === element.uuid)) {
                element.label = element.brand_name + " " + element.model;
                this.modelOptions.push(element);
              }
            });
            resolve();
          });
      });
    },
  },
};
</script>
